import { HTMLAttributes, memo } from 'react';
import { cn } from '@/lib/utils';

export interface SpinnerProps extends HTMLAttributes<HTMLDivElement> {
  size?: 'sm' | 'md' | 'lg';
  /** Color variant */
  variant?: 'primary' | 'white' | 'secondary';
}

/**
 * Spinner (memoized) - Indicador de carga con estilos Tailwind Plus
 * 
 * Mejoras aplicadas:
 * - Variantes de color
 * - Uso de size-* en lugar de w-* h-*
 * - Mejor animación
 */
const sizeClasses = {
  sm: 'size-4',
  md: 'size-8',
  lg: 'size-12',
};

const variantClasses = {
  primary: 'text-primary-600 dark:text-primary-400',
  white: 'text-white',
  secondary: 'text-secondary-500 dark:text-secondary-400',
};

export const Spinner = memo(function Spinner({ 
  size = 'md', 
  variant = 'primary',
  className = '', 
  ...props 
}: SpinnerProps) {
  return (
    <div className={cn('inline-block', className)} {...props}>
      <svg
        className={cn(
          'animate-spin',
          sizeClasses[size],
          variantClasses[variant]
        )}
        fill="none"
        viewBox="0 0 24 24"
        role="status"
        aria-label="Loading"
      >
        <circle 
          className="opacity-25" 
          cx="12" 
          cy="12" 
          r="10" 
          stroke="currentColor" 
          strokeWidth="4" 
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
      </svg>
    </div>
  );
});
